// extracted by mini-css-extract-plugin
export default {"wrapper":"UserDataRow_wrapper__0rrPt","deleteBtn":"UserDataRow_deleteBtn__t5Up1","userList":"UserDataRow_userList__hk49C","inactiveRow":"UserDataRow_inactiveRow__75hEH"};